<template>
	<ul
		class="links"
		v-if="parsedLinks"
	>
		<li
			v-for="(link, index) in parsedLinks"
			:key="index"
		>
			<span>
				<h5
					v-if="link.label"
					v-html="link.label"
				></h5>
				<caption v-if='link.description' v-html='link.description'></caption>
			</span>
			<span>
				<secondary-button
					v-if="link.cta"
					:label="link.type === 'file' ? (link.cta.url ? 'Download ' + getFileExtension(link.cta.url) : 'Download File') : (link.cta.target === '_blank' ? 'External Link' : 'View')"
					:link="link.cta.url"
					:theme="'dark'"
					:type="link.type"
				></secondary-button>

			</span>
		</li>
	</ul>
</template>

<script>
import SecondaryButton from './SecondaryButton.vue';

export default {
	data() {
		return {};
	},

	props: {
		title: {},
		downloads_and_links: {},
	},

	computed: {
		parsedLinks() {
			if (this.downloads_and_links) {
				return JSON.parse(this.downloads_and_links);
			} else {
				return null;
			}
		},
	},

	watch: {},

	methods: {
		getFileExtension(fileObject) {
      if (fileObject && fileObject.filename) {
        // Extract the file extension from the filename
        const extension = fileObject.filename.split('.').pop();
        return extension.toUpperCase();
      }
      return null; // Return null if the fileObject or filename is invalid
    },
	},

	components: {
		SecondaryButton,
	},

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.links_downloads {
	padding: 32px 0;

	.page-template-template-side_nav & {
		padding: 0 24px;
	}

	.title {
		grid-column: 3 / span 8;

		@media (max-width: $mobile-xl) {
			margin-bottom: 32px;
		}

		&::v-deep {
			text-align: center;
		}

		@media (max-width: $tablet) {
			grid-column: 1 / span 12;
		}

		@media (max-width: $mobile) {
			grid-column: 1 / span 4;
		}

		.page-template-template-side_nav & {
			grid-column: 1 / span 12;

			@media (max-width: $mobile-xl) {
				grid-column: 1 / span 4;
			}
		}
	}
}

.links {
	list-style: none;
	padding: 0;
	margin: 0;
	grid-column: 3 / span 8;
	display: flex;
	flex-direction: column;

	@media (max-width: $mobile-xl) {
		grid-column: 1 / span 12;
	}

	@media (max-width: $mobile) {
		grid-column: 1 / span 4;
	}

	.page-template-template-side_nav & {
		grid-column: 1 / span 12;

		@media (max-width: $mobile-xl) {
			grid-column: 1 / span 4;
		}
	}

	li {
		display: grid;
		grid-template-columns: 1fr auto;
		gap: 24px;
		align-items: center;
		width: 100%;
		padding: 16px 0;

		&:last-of-type {
			padding: 16px 0 0;
		}

		.theme--blue & {
			border-top: 1px solid var(--midnight);
		}

		.theme--dark_blue &,
		.theme--white &,
		.theme--none & {
			border-top: 1px solid var(--cobalt);
		}

		@media (max-width: $mobile-xl) {
			display: flex;
			flex-wrap: wrap;
			flex-direction: column;
			gap: 16px;
			justify-content: flex-start;
			align-items: flex-start;
		}

		> span {
			display: flex;
			flex-direction: column;
			gap: 8px;

			@media (max-width: $mobile-xl) {
				justify-content: flex-start;
				align-items: flex-start;
				width: 100%;
				flex-wrap: wrap;
			}

			.theme--blue & {
				.site_button_secondary {
					border: 1px solid var(--white);
					color: var(--white);

					&::v-deep {
						span {
							color: var(--white);
						}

						svg {
							&.external_link_icon {
								path {
									stroke: var(--white);
								}
							}

							&.resource {
								path {
									fill: var(--white);
								}
							}
						}

						&:hover {
							background: var(--white);
							border: 1px solid var(--white);

							span {
								color: var(--midnight);
							}

							svg {
								&.external_link_icon {
									path {
										stroke: var(--cobalt);
									}
								}

								&.resource {
									path {
										fill: var(--cobalt);
									}
								}
							}
						}
					}
				}
			}

			.theme--dark_blue & {
				.site_button_secondary {
					border: 1px solid var(--white);
					color: var(--white);

					&::v-deep {
						span {
							color: var(--white);
						}

						svg {
							&.external_link_icon {
								path {
									stroke: var(--white);
								}
							}

							&.resource {
								path {
									fill: var(--white);
								}
							}
						}

						&:hover {
							background: var(--white);
							border: 1px solid var(--white);

							span {
								color: var(--midnight);
							}

							svg {
								&.external_link_icon {
									path {
										stroke: var(--cobalt);
									}
								}

								&.resource {
									path {
										fill: var(--cobalt);
									}
								}
							}
						}
					}
				}
			}

			.theme--white &,
			.theme--none & {
				.site_button_secondary {
					border: 1px solid var(--midnight);
					color: var(--midnight);

					&::v-deep {
						span {
							color: var(--midnight);
						}

						svg {
							&.external_link_icon {
								path {
									stroke: var(--cobalt);
								}
							}

							&.resource {
								path {
									fill: var(--cobalt);
								}
							}
						}

						&:hover {
							background: var(--midnight);
							border: 1px solid var(--midnight);

							span {
								color: var(--white);
							}

							svg {
								&.external_link_icon {
									path {
										stroke: var(--cobalt);
									}
								}

								&.resource {
									path {
										fill: var(--cobalt);
									}
								}
							}
						}
					}
				}
			}
		}

		h5 {
			color: var(--midnight);
			margin: 0;

			.theme--blue &,
			.theme--dark_blue & {
				color: var(--white);
			}

			@media (max-width: $mobile-xl) {
				text-align: left;
				width: 100%;
			}
		}

		caption {
			text-align: left;

			.theme--blue &,
			.theme--dark_blue & {
				color: var(--white);
			}
		}

		&:hover {
			a {
				span {
					color: var(--midnight-navy);
				}
			}
		}
	}
}
</style>
